import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { HttpService } from 'src/app/services/http-service.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  oculPromociones: boolean = false;
  public current: any;
  constructor(
    public readonly authService: AuthService,
    public readonly httpService: HttpService,
  ) {
    const current = localStorage.getItem('current');
    if (current) {
      this.httpService.getCurrentUser().subscribe(
        (res) => {
          this.current = res;
        },
        (err) => {
          // this.authService.logout();
        },
      );
    }
  }

  ocultarPromociones(event: boolean) {
    this.oculPromociones = event;
  }
}
